import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RobitoLogo from "../components/AppLogo";
import "../App.css";
import { apiPostPublic} from "../utils/api";

export default function ResetPasswordPage() {
  const { email, token } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [validToken, setValidToken] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState("");

  // Validate token
  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await apiPostPublic("check_reset_password_token.php", {
            email: email, token: token
        });

        if (response.result === 1) {
          setValidToken(true);
        } else {
          navigate("/login");
        }
      } catch (error) {
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [email, token, navigate]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Password harus terdiri dari 8 karakter.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Password tidak terkonfirmasi.");
      return;
    }

    setUpdating(true);
    try {
      const response = await apiPostPublic("reset_password.php", {
        email: email, token: token, password: password
      });

      if (response.result === 1) {
        alert("Password telah diubah.");
        navigate("/login");
      } else {
        setError(response.message || "Gagal mengubah password.");
      }
    } catch (error) {
      setError("Terjadi kesalahan, coba lagi nanti.");
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="loading-spinner"></div>
        <p>Validasi token...</p>
      </div>
    );
  }

  if (!validToken) return null; // Prevent rendering if token is invalid

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Atur Ulang Password</h2>
        <form onSubmit={handlePasswordReset} className="form-container">
          <input
            type="password"
            placeholder="Password Baru"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Konfirmasi Password Baru"
            className="input-field"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="primary-button" disabled={updating}>
            {updating ? "Mengubah..." : "Ubah Password"}
          </button>
        </form>
        <div className="copyright">© MySite.co.id 2025</div>
      </div>
    </div>
  );
}
